export const cannotCreateToast = {
  title: "You don't have permission to create this event tracking tool.",
  title_auto:
    'You don\'t have permission to create any Event Tracker, please contact the Store Owner to enable "Edit" permission.',
};
